function collectionReleaseDateSortKey(card) {
  const value = card.dataset.releaseDate || "";
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return "";
  const timestamp = Date.parse(`${value}T00:00:00Z`);
  return Number.isFinite(timestamp) && new Date(timestamp).toISOString().slice(0, 10) === value ? value : "";
}

async function loadCollectionTypeGroups(wrapper) {
  if (wrapper.dataset.groupsLoading) return;
  wrapper.dataset.groupsLoading = "true";
  const sectionId = wrapper.dataset.sectionId;
  const section = wrapper.closest(".shopify-section");
  const pagination = section.querySelector("[data-collection-pagination]");
  const status = section.querySelector("[data-collection-group-status]");
  const currentPage = Number(wrapper.dataset.currentPage);
  const totalPages = Number(wrapper.dataset.totalPages);
  const pages = new Map();
  pages.set(currentPage, [...wrapper.querySelectorAll(".collection-product-card")]);
  status.hidden = false;
  status.textContent = status.dataset.loading;
  wrapper.setAttribute("aria-busy", "true");
  try {
    for (let page = 1; page <= totalPages; page += 1) {
      if (page === currentPage) continue;
      const url = new URL(window.location.href);
      url.searchParams.set("page", String(page));
      url.searchParams.set("section_id", sectionId);
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 30000);
      let html;
      try {
        const response = await fetch(url, { signal: controller.signal });
        if (!response.ok) throw new Error(`Collection page ${page}: HTTP ${response.status}`);
        html = await response.text();
      } finally {
        clearTimeout(timeout);
      }
      const remote = new DOMParser().parseFromString(html, "text/html");
      const remoteWrapper = remote.querySelector("[data-collection-type-groups]");
      if (!remoteWrapper || Number(remoteWrapper.dataset.currentPage) !== page ||
          remoteWrapper.dataset.totalProducts !== wrapper.dataset.totalProducts ||
          remoteWrapper.dataset.totalPages !== wrapper.dataset.totalPages) {
        throw new Error(`Collection page ${page} changed or is incomplete`);
      }
      const cards = [...remoteWrapper.querySelectorAll(".collection-product-card")];
      if (!cards.length) throw new Error(`Collection page ${page} has no products`);
      pages.set(page, cards);
    }
    const cards = [...pages.entries()].sort((a, b) => a[0] - b[0]).flatMap(entry => entry[1]);
    const ids = cards.map(card => card.dataset.productId);
    if (cards.length !== Number(wrapper.dataset.totalProducts) ||
        ids.some(id => !id) || new Set(ids).size !== cards.length) {
      throw new Error("Collection product count or identities changed");
    }
    const groups = new Map();
    cards.forEach(card => {
      const rawType = card.dataset.cardProductType || "";
      const type = rawType.trim() ? rawType : "";
      if (!groups.has(type)) groups.set(type, []);
      groups.get(type).push(card);
    });
    const priority = [...new Set(wrapper.dataset.typeOrder.split(",").map(type => type.trim()).filter(Boolean))];
    const sortedTypes = [...groups.keys()].filter(Boolean).sort((a, b) =>
      a.toLowerCase().localeCompare(b.toLowerCase()));
    const types = [...new Set([...priority.filter(type => groups.has(type)), ...sortedTypes])];
    if (groups.has("")) types.push("");
    const fragment = document.createDocumentFragment();
    types.forEach(type => {
      const heading = document.createElement("div");
      heading.className = "product-type-heading bold";
      heading.dataset.productType = type;
      const title = document.createElement("h2");
      title.textContent = type || wrapper.dataset.otherLabel;
      heading.appendChild(title);
      fragment.appendChild(heading);
      groups.get(type).sort((a, b) =>
        collectionReleaseDateSortKey(b).localeCompare(collectionReleaseDateSortKey(a))).forEach(card => {
        card.style.display = "block";
        card.classList.add("animate");
        fragment.appendChild(card);
      });
    });
    wrapper.querySelectorAll(".product-type-heading").forEach(heading => heading.remove());
    wrapper.appendChild(fragment);
    initializeQuantityButtons(wrapper);
    initializeAddToCartForms();
    cards.filter(card => !card.hasAttribute("data-variant-initialized")).forEach(card => {
      const selector = card.querySelector(".variant-selector");
      if (selector) updateSelectedCardVariant(selector);
      card.setAttribute("data-variant-initialized", "true");
    });
    if (pagination) pagination.hidden = true;
    status.hidden = true;
    wrapper.dataset.groupsComplete = "true";
  } catch (error) {
    console.error("Collection Type grouping failed:", error);
    status.textContent = status.dataset.error;
    if (pagination) pagination.hidden = false;
  } finally {
    delete wrapper.dataset.groupsPending;
    wrapper.removeAttribute("aria-busy");
  }
}

function initializeCollectionTypeGroups() {
  document.querySelectorAll("[data-collection-type-groups]").forEach(loadCollectionTypeGroups);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initializeCollectionTypeGroups);
} else {
  initializeCollectionTypeGroups();
}
